<ngx-loading-bar color="#002E5B"></ngx-loading-bar>
<router-outlet></router-outlet>